module.exports = __webpack_public_path__ + "img/safety.6977a13b.svg";